export default "__VITE_ASSET__DgyYi7kE__"